import apiClient from "./client";

// ============================================
// LOOKUP TYPES (Master)
// ============================================

/**
 * Get all lookup types for current customer
 */
export function getLookupTypes() {
  return apiClient.get("/lookup/types").then((res) => res.data);
}

/**
 * Get lookup type by ID
 */
export function getLookupType(id) {
  return apiClient.get(`/lookup/types/${id}`).then((res) => res.data);
}

/**
 * Get lookup type by type name
 */
export function getLookupTypeByName(lookupType) {
  return apiClient.get(`/lookup/types/name/${encodeURIComponent(lookupType)}`).then((res) => res.data);
}

/**
 * Create new lookup type
 */
export function createLookupType(payload) {
  return apiClient.post("/lookup/types", payload).then((res) => res.data);
}

/**
 * Update lookup type
 */
export function updateLookupType(id, payload) {
  return apiClient.put(`/lookup/types/${id}`, payload).then((res) => res.data);
}

/**
 * Delete lookup type
 */
export function deleteLookupType(id) {
  return apiClient.delete(`/lookup/types/${id}`).then((res) => res.data);
}

// ============================================
// LOOKUP DATA (Detail)
// ============================================

/**
 * Get lookup data by type
 */
export function getLookupDataByType(lookupType) {
  return apiClient.get(`/lookup/data/type/${encodeURIComponent(lookupType)}`).then((res) => {
    // Handle both old format (array) and new format (object with data property)
    const responseData = Array.isArray(res.data) ? res.data : res.data?.data || res.data;
    const debugInfo = res.data?.debug || {};

    // Extract debug info for troubleshooting
    const customerId = res.headers['x-customer-id'] || debugInfo.customerId;
    const dataCount = res.headers['x-data-count'] || debugInfo.count;

    return responseData;
  });
}

/**
 * Get lookup data by ID
 */
export function getLookupData(id, lookupType) {
  const url = `/lookup/data/${id}`;
  const params = lookupType ? { lookupType } : {};
  return apiClient.get(url, { params }).then((res) => res.data);
}

/**
 * Create new lookup data
 */
export function createLookupData(payload) {
  return apiClient.post("/lookup/data", payload).then((res) => res.data);
}

/**
 * Update lookup data
 */
export function updateLookupData(id, payload) {
  return apiClient.put(`/lookup/data/${id}`, payload).then((res) => res.data);
}

/**
 * Delete lookup data
 */
export function deleteLookupData(id, lookupType) {
  return apiClient.delete(`/lookup/data/${id}`, { params: { lookupType } }).then((res) => res.data);
}
